import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrq936cxhr: FaireProductEntity = {
  token: "p_rrq936cxhr",
  type: "product",
  name: "FROSTIE SODA 4PK BLUE CREAM - Case of 6",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/f38da5d0bf419b9beb30c7e8a71fb4c1f527c2862fcf65517e6242cd6b5147f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/352d72f42086154177a120168a7677bb9b9ab9fab05322f31f58c87f08f68a8b.jpeg",
    "https://cdn.faire.com/fastly/c2f3410262c724615b26b5884bbc061b259762d6c6644664321ef08de0f828a2.jpeg",
  ],
  priceDollars: 62.98,
  description:
    "Made with pure cane sugar Frostie cream soda in long-neck glass bottles are sure to grab attention. Blue cream soda entices shoppers to ‘Take a sip down memory lane’ with a subtle cream flavor finished with delicious blueberry notes. Create the perfect upsell opportunity and merchandise this retro soda favorite next to other nostalgic treats.\n",
  tags: [],
  msrpDollars: 125.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:53.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
